/**
 * Tiny pub-sub pentru toast-uri globale.
 *
 * De ce nu zustand / jotai: e un singur channel, 30 de linii, fara dependinte.
 * AdminBar se aboneaza si randeaza Toast-urile inline in bara.
 * Orice pagina poate apela showToast() fara prop-drilling.
 */

import { useEffect, useState } from 'react';

export type ToastType = 'success' | 'error' | 'info';

export interface ToastMessage {
  id: string;
  type: ToastType;
  text: string;
  /** Durata in ms. Daca lipsa, 3500. */
  duration?: number;
}

type ListenerFn = (msg: ToastMessage) => void;

const listeners = new Set<ListenerFn>();

export function showToast(
  text: string,
  type: ToastType = 'info',
  duration?: number,
): void {
  const msg: ToastMessage = {
    id: `t-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    type,
    text,
    duration,
  };
  for (const fn of listeners) {
    fn(msg);
  }
}

/**
 * Hook pentru AdminBar — se aboneaza la mesaje noi si intoarce
 * coada activa de toast-uri.
 */
export function useToastQueue(): {
  toasts: ToastMessage[];
  dismiss: (id: string) => void;
} {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  useEffect(() => {
    const fn: ListenerFn = (msg) => {
      setToasts((prev) => [...prev, msg]);
    };
    listeners.add(fn);
    return () => {
      listeners.delete(fn);
    };
  }, []);

  const dismiss = (id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  return { toasts, dismiss };
}